<template>
  <div class="fold-view">
    <i class="el-icon-s-fold" v-if="isUnfold"></i>
    <i class="el-icon-s-unfold" v-else></i>
  </div>
</template>

<script>
export default {
  props: {
    isUnfold: { default: true }
  },
  methods: {
    onFoidChange() {
      this.$emit('change', !this.isUnfold);
    }
  }
}
</script>

<style lang="less" scoped>
  .fold-view{
    position: absolute;
    right: 4px;
    bottom: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
    text-align: center;
    line-height: 24px;
    .el-icon-s-fold{
      font-size: 18px;
      line-height: 24px;
      color: #606672;
    }
  }
</style>
